import { AppConnectionStatuses } from 'integrations-lib/constants/appConnectionStatuses';

import { TReconnectConfig } from '../../types/reconnection-config';
import { GoogleSearchConsoleServiceComponent } from './GoogleSearchConsoleServiceComponent';

export const GoogleSearchConsoleReconnectionConfig: TReconnectConfig = {
  statusesForDisplaying: [
    AppConnectionStatuses.DISCONNECTED,
    AppConnectionStatuses.UPDATE_AVAILABLE,
  ],
  serviceComponent: GoogleSearchConsoleServiceComponent,
};
